import { render, staticRenderFns } from "./VtTableListFilter.vue?vue&type=template&id=68f823e6&"
import script from "./VtTableListFilter.vue?vue&type=script&lang=js&"
export * from "./VtTableListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports